import { createFileRoute, redirect } from '@tanstack/react-router';

// Back-compat: the standalone "Call Tree" page is gone, and so is the IVR
// Menu tab that replaced it — Call Flows now draws the keypad tree. Redirect
// any saved/linked /settings/calltree URL there so old bookmarks don't 404.
export const Route = createFileRoute('/_dashboard/dashboard/settings/calltree')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/call-settings', search: { tab: 'flows' } });
  },
});
